import type { BrandIconSize } from '../components/Compounds/src/BrandIconCompound'
import { pascalCase } from './pascalCase'

export const setFillThemeVarColor = (color: string): string => {
  // Normalize to a PascalCase color key
  // Supports : 'u-fillColorDarkMint', 'u-fillColor..'
  const normalize = (c?: string): string => {
    if (!c) return ''
    const token = String(c).trim()
    // Extract Pascal token from u-xyzColor{Token}
    const m = token.match(/^u-(?:fill)Color([A-Za-z0-9]+)$/)
    if (m?.[1]) return m[1] // e.g., "DarkMint"
    return pascalCase(token) // e.g., "dark-mint" -> "DarkMint"
  }
  const key = normalize(color)

  const glyphs: Record<string, string> = {
    ActionBlue: '#046cb8',
    MidnightBlue: '#00284a',
    Neutral: '#1f2226',
    Neutral75: '#1F2226BF',
    Alert: '#B81237',
    Confirm: '#44790B',
    White: '#fff',
    AmpfBlue: '#003d6d',
    Berry: '#972364',
    Lime: '#bdd753',
    DarkMint: '#007886',
    Purple: '#462c67',
    Orange: '#e3780d',
    Mint: '#44a29a',
    LightBlue: '#009fb8',
    DarkStone: 'D9D8D7',
    Stone: 'F3F2F1',
    Data1: '#2A6B9A',
    Data2: '#76BCB6',
    Data3: '#F7A44A',
    Data4: '#A188C2',
    Data5: '#9CDFE9',
    Data6: '#9CDFE9',
    Data7: '#BDD753',
    Data8: '#FDD835',
    Data9: '#A2587C',
    Data10: '#00A0DD',
    Data11: '#75BEE9',
    Data12: '#247139',
    Data13: '#83B340',
    Data14: '#505659',
    Data15: '#959898',
    Data16: '#977567',
    Data17: '#D8AA87',
    Data18: '#E57465',
    Data19: '#F7ADAF',
    Data20: '#0A7986',
  }
  if (key && glyphs[key]) return glyphs[key]
  // fallback: Brand blue hex
  return '#003d6d'
}

export const setBrandIconClass = (
  stylesDropdown: string | undefined,
  enableBorder: boolean | string | undefined,
  iconsColorsDropdown: string | undefined
): string => {
  if (stylesDropdown?.endsWith('brand-icons-fill-colors')) {
    return enableBorder ? 'BrandIcon--withFillColorBorder' : 'BrandIcon--default'
  }

  if (stylesDropdown?.endsWith('brand-icons-background-colors')) {
    const fillOverride =
      iconsColorsDropdown === 'u-bgColorWhite' ? 'u-fillAmpfBlue' : 'u-fillColorWhite'
    return `BrandIcon--withBgColor ${fillOverride}`
  }

  return 'BrandIcon--default'
}

export const brandIconSize = (size: BrandIconSize): string => {
  switch (size) {
    case 'small':
      return 'u-sizeSmall'
    case 'large':
      return 'u-sizeLarge'
    default:
      return 'u-sizeDefault'
  }
}
